export default __webpack_public_path__ + "assets/androidQrCodeCenter-782389e9a0f25875927310f77d693c72.svg";